import { DreamsSearch } from '@/features/dreams/search'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/dreams/search')({
  component: RouteComponent,
})

function RouteComponent() {
  return <DreamsSearch />
}
